import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['map'];

  connect() {
    const lat = parseFloat(this.data.get('lat'));
    const lng = parseFloat(this.data.get('lng'));

    this.map = new google.maps.Map(this.mapTarget, {
      zoom: 17,
      center: { lat, lng },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: true,
      scrollwheel: false,
    });

    this.marker = new google.maps.Marker({
      map: this.map,
      position: { lat, lng },
      draggable: false,
    });
  }
}
